var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_8060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88817 12.2818C6.19939 12.593 6.70389 12.5933 7.01546 12.2824L10.1212 9.18341L13.2269 12.2824C13.5385 12.5933 14.043 12.593 14.3542 12.2818V12.2818C14.6657 11.9703 14.6657 11.4653 14.3542 11.1539L10.8283 7.62795C10.4378 7.23742 9.8046 7.23742 9.41408 7.62795L5.88817 11.1539C5.57671 11.4653 5.57671 11.9703 5.88817 12.2818V12.2818Z",
    fill: "#34639C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_8060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1879,
    height: 19.1879,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.527344 19.7128)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectActive);
export default __webpack_public_path__ + "static/media/IconSelectActive.28769cf41ec8f9d71da1ad52e63e027a.svg";
export { ForwardRef as ReactComponent };